import { useEffect } from "react";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Navbar from "@/sections/Navbar";
import Hero from "@/sections/Hero";
import Marquee from "@/sections/Marquee";
import BurnCounter from "@/sections/BurnCounter";
import ContractSection from "@/sections/ContractSection";
import About from "@/sections/About";
import Tokenomics from "@/sections/Tokenomics";
import HowToBuy from "@/sections/HowToBuy";
import LiveInfo from "@/sections/LiveInfo";
import Roadmap from "@/sections/Roadmap";
import Community from "@/sections/Community";
import FAQ from "@/sections/FAQ";
import RiskDisclosure from "@/sections/RiskDisclosure";
import Footer from "@/sections/Footer";

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const el = document.querySelector(anchor.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -72 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="min-h-screen overflow-x-clip bg-[#050203] font-body text-zinc-100 antialiased">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <BurnCounter />
          <ContractSection />
          <About />
          <Tokenomics />
          <HowToBuy />
          <LiveInfo />
          <Roadmap />
          <Community />
          <FAQ />
          <RiskDisclosure />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
